<div class="space"></div>

<div class="lightgray">
	<section id="slider">
		<div class="slide">
			<div class="somos">
				<div class="wrapper">
					<div class="info anime-element fadeleft-animation">
						<div class="gtitle">
							<h2>{{ 'cloud.title226' | translate }} <span>{{ 'cloud.title227' | translate }}</span><br></h2>
						</div>
						<div class="fluid">
							<div class="piece">
								<ul>
									<li>{{ 'cloud.title228' | translate }}</li>
									<li>{{ 'cloud.title229' | translate }}</li>
									<li>{{ 'cloud.title230' | translate }}</li>
								</ul>
							</div>
							<div class="sim-button button14" (click)='scroll(ibox)'>
                                <span>{{ 'cloud.title231' | translate }}</span>
                                <img class="arrow22" src="../../../../assets/img/blueArrow.svg" alt="arrow">
                                <img class="warrow22" src="../../../../assets/img/arrow.svg" alt="arrow">
                            </div>
						</div>
					</div>
					<div class="foto">
						<img src="../../../../assets/img/sap/clouds.png" alt="">
					</div>
					<div class="box9">
						<img class="gcp" src="../../../../assets/img/sap/gcp.svg" alt="">
					</div>
					<div class="box10">
						<img class="sap" src="../../../../assets/img/sap/sap.svg" alt="">
					</div>
					<div class="circle"></div>
				</div>
			</div>
		</div>
	</section>
</div>

<div class="space"></div>

<div class="content-area">  
	<div class="wrap">
		<section id="copy">
			<div class="barra">
				<p class="select">{{ 'cloud.title232' | translate }}<br><span>{{ 'cloud.title233' | translate }}</span></p>
			</div>
		</section>
		<section class="rw-wrapper">
				<h2 class="rw-sentence">
					<div class="rw-words rw-words-1">
						<span>{{ 'cloud.title234' | translate }}</span>
						<span>{{ 'cloud.title235' | translate }}</span>
						<span>{{ 'cloud.title236' | translate }}</span>
						<span>{{ 'cloud.title234' | translate }}</span>
						<span>{{ 'cloud.title235' | translate }}</span>
						<span>{{ 'cloud.title236' | translate }}</span>
					</div>
				</h2>
			</section>
	</div>
</div>





		<section id="beneficios">
			<div class="box">
				<div class="title">
					<h2>{{ 'cloud.title237' | translate }}</h2>
				</div>
				<div class="flex6 website">
					<div class="elementb">
						<div class="piece left">
							<img class="reicon" src="../../../../assets/img/sap/reduce-icon.svg" alt="">
						</div>
						<div class="piece right">
							<h3>160%</h3>
							<p>{{ 'cloud.title238' | translate }}</p>
						</div>
					</div>
					<div class="elementb">
						<div class="piece left">
							<img class="reicon" src="../../../../assets/img/sap/return-icon.svg" alt="">
						</div>
						<div class="piece right">
							<h3>ROI</h3>
							<p>{{ 'cloud.title239' | translate }}</p>
						</div>
					</div>
				</div>
			</div>
			<div class="barra21">
				<div class="flex">
					<div class="bar">
						<div class="iflex">
							<div class="bar8" style="text-align: right;justify-content: flex-end;">
								<h3>{{ 'cloud.title240' | translate }}</h3>
							</div>
							<div class="bar8" style="flex: 0 1 90px;"></div>
						</div>
						<div class="iflex">
							<div class="bar8" style="text-align: right;justify-content: flex-end;">
								<p>{{ 'cloud.title241' | translate }}</p>
							</div>
							<div class="bar8" style="flex: 0 1 90px;">
								<img class="number1" src="../../../../assets/img/sap/01.svg" alt="">
							</div>
						</div>
						<div class="iflex">
							<div class="bar8" style="text-align: right;justify-content: flex-end;">
								<p>{{ 'cloud.title242' | translate }}</p>
							</div>
							<div class="bar8" style="flex: 0 1 90px;">
								<img class="number1" src="../../../../assets/img/sap/02.svg" alt="">
							</div>
						</div>
						<div class="iflex">
							<div class="bar8" style="text-align: right; justify-content: flex-end;">
								<p>{{ 'cloud.title243' | translate }}</p>
							</div>
							<div class="bar8" style="flex: 0 1 90px;">
								<img class="number1" src="../../../../assets/img/sap/03.svg" alt="">
							</div>
						</div>
						<div class="iflex">
							<div class="bar8" style="text-align: right;justify-content: flex-end;">
								<p>{{ 'cloud.title244' | translate }}</p>
							</div>
							<div class="bar8" style="flex: 0 1 90px;">
								<img class="number1" src="../../../../assets/img/sap/04.svg" alt="">
							</div>
						</div>
					</div>
					<div class="bar">
						<div class="fluid8">
							<img class="prism" src="../../../../assets/img/sap/prism.svg" alt="">
						</div>
					</div>
					<div class="bar">
						<div class="iflex">
							<div class="bar8" style="flex: 0 1 90px;"></div>
							<div class="bar8" style="text-align: left;justify-content: flex-start;">
								<h3>{{ 'cloud.title245' | translate }}</h3>
							</div>
						</div>
						<div class="iflex">
							<div class="bar8" style="flex: 0 1 90px;">
								<img class="number1" src="../../../../assets/img/sap/01.svg" alt="">
							</div>
							<div class="bar8" style="text-align: left;justify-content: flex-start;">
								<p><span>98%</span> {{ 'cloud.title246' | translate }}</p>
							</div>
						</div>
						<div class="iflex">
							<div class="bar8" style="flex: 0 1 90px;">
								<img class="number1" src="../../../../assets/img/sap/02.svg" alt="">
							</div>
							<div class="bar8" style="text-align: left;justify-content: flex-start;">
								<p><span>35%</span> {{ 'cloud.title247' | translate }}</p>
							</div>
						</div>
						<div class="iflex">
							<div class="bar8" style="flex: 0 1 90px;">
								<img class="number1" src="../../../../assets/img/sap/03.svg" alt="">
							</div>
							<div class="bar8" style="text-align: left;justify-content: flex-start;">
								<p><span>25%</span> {{ 'cloud.title248' | translate }}</p>
							</div>
						</div>
						<div class="iflex">
							<div class="bar8" style="flex: 0 1 90px;">
								<img class="number1" src="../../../../assets/img/sap/04.svg" alt="">
							</div>
							<div class="bar8" style="text-align: left;justify-content: flex-start;">
								<p><span>31%</span> {{ 'cloud.title249' | translate }}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>



<div class="content-area">  
	<div class="wrap">
		<section id="servicios" class="cube">
			<div class="w100">
				<h4>{{ 'cloud.title250' | translate }}</h4>
				<h3 style="padding: 30px 0 0 0;">{{ 'cloud.title251' | translate }} <span>{{ 'cloud.title252' | translate }}</span></h3>
				<h4>{{ 'cloud.title253' | translate }}</h4>
			</div>

			<div class="flex21 website">
				<div class="element21">
					<div class="high">
						<img class="imob" src="../../../../assets/img/sap/heart.svg" alt="">
						<h2 style="color:#ea4335;">8h</h2>
						<h3>{{ 'cloud.title254' | translate }}</h3>
						<p>{{ 'cloud.title255' | translate }}</p>
						
					</div>
					<div class="low" style="background:#ea4335">
						<h3>On-Prem</h3>
					</div>
				</div>
				<div class="element21">
					<div class="high center">
						<div class="barra8">
							<img class="imob" src="../../../../assets/img/sap/sgmail.svg" alt="">
						</div>
						<div class="barra8">
							<img class="wsap" src="../../../../assets/img/sap/wsap.svg" alt="">
						</div>
					</div>
					<div class="low" style="background:#4285f5;">
						<h3>Live Migration</h3>
					</div>
				</div>
				<div class="element21">
					<div class="high">
						<img class="imob" src="../../../../assets/img/sap/sheart.svg" alt="">
						<h2 style="color:#34a853;">0 min</h2>
						<h3>{{ 'cloud.title256' | translate }}</h3>
						<p>{{ 'cloud.title257' | translate }}</p>
					</div>
					<div class="low" style="background: #34a853;">
						<h3>{{ 'cloud.title258' | translate }}</h3>
					</div>
				</div>
			</div>
			<div class="space"></div>
			<div class="flex22">
				<div class="box12">
					<div class="ebox">
						<div class="up">
							<img src="../../../../assets/img/sap/gcp.svg" alt="">
							<h3>{{ 'cloud.title259' | translate }}</h3>
							<p>{{ 'cloud.title260' | translate }}<br><br>
							<span>Google Cloud</span> {{ 'cloud.title261' | translate }}</p>
						</div>
					
					</div>
					<div class="ebox">
						<div class="up">
							<img class="vm" src="../../../../assets/img/sap/vm.webp" alt="">
							<h3>Custom Machines</h3>
							<p><span>Google Cloud</span> {{ 'cloud.title262' | translate }}</p>
						</div>
						<!-- <div class="down"></div> -->
						
					</div>
				</div>
			</div>

		</section>
	</div>
</div>





<div class="darkblue">
	<section id="servicios">
	    <div class="wrapper">
	        <div class="two-col">
	            <div class="graph">
	                <img class="gplus" src="../../../../assets/img/sap/sap_gcp.webp" alt="">
	            </div>
	            <div class="info">
	                <h3>{{ 'cloud.title263' | translate }}</h3>
	                <p>{{ 'cloud.title264' | translate }}</p>


	                <div class="service e-commerce">
	                	<img class="mapas" src="../../../../assets/img/sap/whitecloud.svg" alt="">
	                    <h4>{{ 'cloud.title265' | translate }}</h4> 
	                    <p>{{ 'cloud.title266' | translate }}</p>
	                </div>
	                <div class="service e-commerce">
	                	<img class="routes" src="../../../../../assets/img/sap/team-icon.svg" alt="">
	                    <h4>{{ 'cloud.title267' | translate }}</h4>
	                    <p>{{ 'cloud.title268' | translate }}</p>
	                </div>
	                <div class="service e-commerce">
	                	<img class="places" src="../../../../../assets/img/sap/integral-icon.svg" alt="">
	                    <h4>{{ 'cloud.title269' | translate }}</h4>
	                    <p>{{ 'cloud.title270' | translate }}</p>
	                </div>


	            </div>
	        </div>
	    </div>
	</section>
</div>


<div class="liteblue">
	<section id="xtras">
		<img class="hand" src="../../../../assets/img/sap/hand.webp" alt="">
		<div class="wrapper">
			<div class="flex18">
				<div class="box18">
					<h2><span>{{ 'cloud.title271' | translate }}</span><br> {{ 'cloud.title272' | translate }}</h2>
					<div class="ibar"></div>
					<ul>
						<li>{{ 'cloud.title273' | translate }}</li>
						<li>{{ 'cloud.title274' | translate }}</li>
					</ul>
				</div>
				<div class="box18">
					<h3>{{ 'cloud.title275' | translate }} <span>{{ 'cloud.title276' | translate }}</span></h3>
					<ul>
						<li>{{ 'cloud.title277' | translate }}</li>
						<li>{{ 'cloud.title278' | translate }}</li>
						<li>{{ 'cloud.title279' | translate }}</li>
						<li>SAP Intelligent Technologies.</li>
						<li>{{ 'cloud.title280' | translate }}</li>
					</ul>
				</div>
			</div>
		</div>
	</section>
</div>


<div class="content-area">  
	<div class="wrap">
		<section>
			<article class="intereses">
		        <div class="wrapper">
		            <h3>{{ 'cloud.title281' | translate }}</h3>
		            <div class="card-wrapper">

		                <div class="card" routerLink="/gcp">
		                    <img class="ncloud" src="../../../../../assets/img/gplatform.svg" alt="google cloud platform">
		                    <img class="arrow" src="../../../../assets/img/blue-arrow.svg" alt="arrow">
		                </div>
		                
		            </div>
		        </div>
		    </article>
		</section>
	</div>
</div>


<div #ibox style="margin-bottom: -40px;">
	<app-form></app-form>
</div>






		